import { render, staticRenderFns } from "./app-icon-link.vue?vue&type=template&id=a5cf03c4&lang=pug"
import script from "./app-icon-link.vue?vue&type=script&lang=js"
export * from "./app-icon-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports